<template>
  <wgu-module-card v-bind="$attrs" :moduleName="moduleName" class="wgu-attributetable-win" :icon="icon"
    @windowOpened="onWindowOpen">
    <template v-slot:wgu-win-toolbar>
      <v-row dense class="mx-2">
        <v-col cols="4">
          <div class="summary-text">总保险数量：{{ totalInsuredArea }}亩 总被保险人数量：{{ totalInsuredPeople }}户</div>
        </v-col>
        <v-col cols="2" >
          <v-select dense label="险种信息"
            v-model="formData.crop_id"
            :items="authorizedCrops"
            item-text="text" item-value="value"
            class="wgu-vector-layer-select wgu-solo-field"
            clearable>
          </v-select>
        </v-col>
        <v-col cols="2" >
          <v-text-field v-model="formData.insured_name" label="被保险人姓名" dense
            class="wgu-vector-layer-select wgu-solo-field"
            clearable>
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-btn color="primary" @click="handleSubmit" class="ks-toolbar-btn">
            <v-icon left>mdi-table-edit</v-icon>
            查询
          </v-btn>
          <v-btn color="success" @click="exportToExcel" class="ks-toolbar-btn ml-2">
            <v-icon left>mdi-file-excel</v-icon>
            导出
          </v-btn>
        </v-col>
      </v-row>
    </template>

    <wgu-attributetable ref="attributeTable" :tableData="tableData" :syncTableMapSelection="syncTableMapSelection"
      @selection-changed="onSelectionChanged">
    </wgu-attributetable>
  </wgu-module-card>
</template>

<script>
import ModuleCard from './../modulecore/ModuleCard';
import { Mapable } from '../../mixins/Mapable';
import { ColorTheme } from '../../mixins/ColorTheme';
import AttributeTable from './AttributeTable';
import axios from '@/axios';
import VectorLayer from 'ol/layer/Vector';
import Option from '../../const/Option.js';
import * as XLSX from 'xlsx';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'wgu-attributetable-win',
  inheritAttrs: false,
  props: {
    icon: { type: String, required: false, default: 'table_chart' },
    syncTableMapSelection: { type: Boolean, required: false, default: false }
  },
  data () {
    return {
      moduleName: 'wgu-attributetable',
      options: Option,
      layers: [],
      selLayer: null,
      parcelName: '',
      trusteeName: '',
      disasterHeaders: [],
      tableData: [],
      requestParams: {
        parcelName: '',
        trusteeName: ''
      },
      dialog: false,
      menu: false,
      formData: {
        crop_id: '',
        insured_name: ''
      },
      selectedRows: [],
      selectedItems: [],
      selectedArea: null // Add this property to store the selected area
    }
  },
  created () {
    // this.fetchTableData();
  },
  mixins: [Mapable, ColorTheme],
  components: {
    'wgu-module-card': ModuleCard,
    'wgu-attributetable': AttributeTable
  },
  watch: {
    parcelName (val) {
      this.requestParams.parcelName = val;
      this.fetchTableData();
    },
    trusteeName (val) {
      this.requestParams.trusteeName = val;
      this.fetchTableData();
    }
  },
  methods: {
    resolveCropFilter () {
      if (!this.formData.crop_id) return '';
      const matched = this.authorizedCrops.find(item => String(item.value) === String(this.formData.crop_id));
      return matched ? matched.text : this.formData.crop_id;
    },
    async fetchTableData () {
      if (!this.selectedVillage?.place_id) {
        this.showMessage('请先选择行政区域', 'warning');
        return;
      }
      this.isLoading = true; // 设置加载状态为true

      try {
        const requestBody = {
          page: 1,
          page_size: 1000,
          village_code: this.selectedVillage?.place_id,
          ...this.formData,
          crop_id: this.resolveCropFilter()
        };

        // get jwt token
        const jwtToken = localStorage.getItem('jwt');
        if (!jwtToken) {
          throw new Error('JWT token not found in localStorage');
        }

        const headers = {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        };

        const response = await axios.post('/policies/list', requestBody, { headers });
        this.tableData = response.data.items;
        console.log('Table data:', this.tableData);
        if (response.data.disasterHeaders) {
          this.disasterHeaders = response.data.disasterHeaders;
        }
      } catch (error) {
        console.error('Failed to fetch table data:', error);
      }
    },
    onWindowOpen () {
      this.fetchTableData();
    },
    onSelectionChanged (selected) {
      this.selectedItems = selected;
    },
    handleSubmit () {
      this.fetchTableData();
      // if (!this.selectedItems || this.selectedItems.length === 0) {
      //   alert('请先选择要修改的数据');
      //   return;
      // }
      // this.selectedRows = this.selectedItems;
      // // 填充表单数据，这里以第一条选中数据为例
      // const firstSelected = this.selectedRows[0];
      // Object.keys(this.formData).forEach(key => {
      //   this.formData[key] = firstSelected[key];
      // });
      // this.dialog = true;
    },
    async trusteeConfirm () {
      try {
        const response = await axios.post('/?_c=api&_a=upsertAgInputs', {
          ids: this.selectedRows.map(row => row.id),
          ...this.formData
        });
        if (response.data.success) {
          this.dialog = false;
          this.fetchTableData(); // 刷新表格数据
        } else {
          alert('更新失败：' + response.data.message);
        }
      } catch (error) {
        console.error('Failed to update data:', error);
        alert('更新失败，请检查网络连接');
      }
    },
    exportToExcel () {
      try {
        if (!this.tableData || this.tableData.length === 0) {
          alert('没有可导出的数据');
          return;
        }

        // 处理导出数据
        const exportData = this.tableData.map((item, index) => ({
          序号: index + 1,
          被保险人: item.insured_name || '',
          证件号码: item.id_number || '',
          被保险人地址: item.insured_address || '',
          标的名称: item.subject_name || '',
          标的详细名称: item.subject_detail || '',
          地块编码: item.land_code || '',
          种植地点: item.planting_location || '',
          保险数量: item.insurance_quantity ? parseFloat(item.insurance_quantity).toFixed(1) : '',
          单位保额: item.unit_amount || '',
          保险金额: item.insurance_amount || '',
          保险费率: item.insurance_rate ? `${item.insurance_rate}%` : '',
          保险费: item.insurance_premium || ''
        }));

        // 创建工作簿
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(exportData);

        // 添加工作表到工作簿
        XLSX.utils.book_append_sheet(wb, ws, '保险数据');

        // 生成文件名
        const fileName = `保险数据_${new Date().toLocaleDateString()}.xlsx`;

        // 保存文件
        XLSX.writeFile(wb, fileName);
      } catch (error) {
        console.error('导出失败:', error);
        alert('导出失败，请稍后重试');
      }
    },

    getInsuranceTypeName (cropId) {
      const insuranceType = this.options.nzSetting.INSURANCE_TYPE.list.find(
        item => item.value === cropId
      );
      return insuranceType ? insuranceType.text : '';
    }
  },
  computed: {
    ...Mapable.computed,
    ...mapState(['authorizedArea']),
    ...mapGetters(['getCodesByType']),
    authorizedCrops () {
      console.log('authorizedArea:', this.authorizedArea);
      // First try to get crops from authorizedArea.results
      if (this.authorizedArea && this.authorizedArea?.length > 0) {
        return this.getCodesByType(this.authorizedArea[0].organize);
      }
      // Fallback to the original getCodesByType method
      return this.getCodesByType('CROP');
    },
    selectedVillage () {
      return this.$store.state.selectedArea;
    },
    /**
     * Reactive property to return the OpenLayers vector layers to be shown in the selection menu.
     */
    displayedLayers () {
      return this.layers
        .filter(layer =>
          layer instanceof VectorLayer &&
          layer.get('lid') !== 'wgu-measure-layer' &&
          layer.get('lid') !== 'wgu-geolocator-layer'
        )
        .reverse();
    },
    // Calculate total insured area from tableData
    totalInsuredArea () {
      if (!this.tableData || this.tableData.length === 0) return 0;
      // Sum up the insured area from all records
      const total = this.tableData.reduce((sum, item) => {
        const area = Number(item.insurance_quantity || 0);
        return sum + area;
      }, 0);
      return total.toFixed(2); // Format to 2 decimal places
    },
    // Calculate total number of unique insured people
    totalInsuredPeople () {
      if (!this.tableData || this.tableData.length === 0) return 0;
      // Count unique insured people by their IDs or names
      // Assuming insured person is identified by 'insured_name' or similar
      // Adjust the field name according to your actual data structure
      const uniqueInsured = new Set();
      this.tableData.forEach(item => {
        if (item.insured_name) {
          uniqueInsured.add(item.insured_name);
        }
      });
      return uniqueInsured.size;
    }
  }
};
</script>

<style scoped>
/* TODO
    Generalize the positioning concept for windows,
    this interferes with positioning and draggable settings in the app.conf */

.wgu-vector-layer-select,
.search-field {
  margin-top: 25px;
}

.wgu-attributetable-win.wgu-floating {
  top: inherit !important;
  position: relative;
  bottom: 35px;
  height: 90% !important;
}

.wgu-solo-field.v-text-field ::v-deep input {
  caret-color: white !important;
  color: white !important;
}

.wgu-solo-field.v-text-field ::v-deep label {
  color: rgba(255, 255, 255, 0.7) !important;
}

.wgu-solo-field.v-text-field.v-input--is-focused ::v-deep .v-input__slot {
  border-color: white !important;
}

.btn-position {
  margin-top: 10px !important;
}

.ks-toolbar-btn {
  margin-top: 16px !important;
}

.summary-text {
  color: white;
  margin-top: 25px;
  font-size: 14px;
  white-space: nowrap;
}
</style>
